//@import dependencies
import React, {useState, useEffect} from 'react'
//@end

//@import components
import PublicAppContainer from 'app_components/layouts/public'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import InputComponent from 'app_components/commons/Input/InputComponent'
import ForumCard from 'app_components/commons/ForumCard/ForumCard'
import PaginationCommon from 'app_components/commons/pagination'
import ButtonWithLogin from 'app_components/modules/ButtonWithLogin/ButtonWithLogin'
import ModalFormForum from 'app_components/modules/ModalFormForum/ModalFormForum'
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
// @end

// @INFO Import types
import { IForumListItem } from 'app_types/admin/forum/forumTypes';
// @end

// @INFO Import services
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
import ForumService from 'app_services/admin/forum/forumService'
// @end

// @INFO Import Styles
import './../forumsScreen.scss'
import ForumCategoryService from 'app_services/admin/forum/forumCategoryService'
import ReactSelectComponent from 'app_components/commons/reactSelect';
import { useForm } from 'react-hook-form';
import AlertComponent from 'app_components/commons/alert'

// @ADD Component types
interface IForumsScreenLayoutProps {}

interface Paginator{
  page: number
  perPage: number
  total: number
}

const ForumsScreenLayout: React.FC<IForumsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [openNewForm, updateOpenNewForm] = useState<boolean>(false);
  const [listOfForumCategory, setListOfForumCategory] = useState<Array<any>>([])
  const [searchStr, updateSearchStr] = useState<string>('');
  const [category, updateCategory] = useState<string | undefined>(undefined);
  const [forums, updateForums] = useState<IForumListItem[]>([]);
  const formHook = useForm();
  const [paginator, updatePaginator] = useState<Paginator>({
    page: 1,
    perPage: 10,
    total: 0
  });

  // @INFO Servicios
  const screenNotification = new ScreenNotificationsUtil();
  const forumCategoryService: ForumCategoryService = new ForumCategoryService();
  const forumService = new ForumService();

  useEffect(() => {
    if (paginator.page) {
      // TODO: Hacer el fetch de los foros
      handleOnSearch()
    }
  }, [paginator.page])

  useEffect(() => {
    getForumCategories()
  }, [])

  useEffect(() => {
    handleOnSearch()
  }, [category])

  const handleOnSearch = async (data?: any) => {
    const paramsSearch: any = {
      pageNumber: data ? 1 : paginator.page,
      nPerPage: paginator.perPage,
      isActive: true,
      search: searchStr,
    }
    if (category) {
      paramsSearch.category = category
    }
    const response = await forumService.list(paramsSearch);
    // Actualizar el paginador y guardar los items si llega una respuesta exitosa
    if (response?.forums) {
      updatePaginator({
        perPage: response.nPerPage,
        page: response.pageNumber,
        total: response.total_register
      });
      updateForums(response.forums);
    }
  }

  const getForumCategories = async () => {
    const categories: Array<any> = []
    const forumCategoriesResponse = await forumCategoryService.list()
    if (forumCategoriesResponse) {
      forumCategoriesResponse.forumCategories.map((type: any) => {
        categories.push({ value: type._id, label: type.name })
      })
    }
    setListOfForumCategory(categories)
  }

  const handleChangePage = (newPage: number) => {
    updatePaginator({
      ...paginator,
      page: newPage
    })
  }

  const handleCloseModal = async (data?: {response?: any, created?: boolean}) => {
    if (data?.created) {
      await screenNotification.showSuccessTimer({
        text: 'El foro ha sido creado exitosamente'
      })
      if (data?.response) {
        updateForums([data?.response ,...forums])
      }
    }
    updateOpenNewForm(false);
  }

  const handleSearchForums = () => {
    handleOnSearch()
  }

  const handleChangeCategory = (data: any) => {
    if (data.value) {
      updateCategory(data.value)
    } else {
      updateCategory(undefined)
    }
  }

  return(
    <PublicAppContainer>
      <div className='forums_screen-layout'>
        <TextComponent
          type='subtitle'
        >
          Foros
        </TextComponent>
        <div className="container-fields-filter">
          {/* <InputComponent
            placeholder='Categorías'
          /> */}
          <div className="col-md-12">
            <div className="form-group">
              <ReactSelectComponent
                identifier='category'
                placeholder='Categoría'
                isCreatable={false}
                options={listOfForumCategory}
                formHooks={formHook}
                defaultValue={[]}
                isMulti={false}
                required={false}
                onChangeSelect={handleChangeCategory}
              />
            </div>
          </div>
          <InputComponent
            placeholder='Buscar'
            onChange={(e) => updateSearchStr(e.target.value)}
            value={searchStr}
            onEnter={handleSearchForums}
          />
        </div>
        <div className="container-list-forums">
          {forums?.length ?
            forums.map((f) => (
              <ForumCard
                key={f._id}
                title={f.title}
                description={f.description}
                forumId={f._id}
                date={f.postDate}
              />
            ))
          :
            <AlertComponent description='No se han encontrado foros' />
          }
        </div>
        <div className="container-paginator-forums">
          <PaginationCommon
            data={paginator}
            onChangePage={handleChangePage}
          />
        </div>
        <div className="container-button-add-question">
          <ButtonWithLogin
            variant='tertiary'
            onClick={() => updateOpenNewForm(true)}
            permissions={[
              {
                module: 'module:forums',
                permissions: ['permission:forums_create']
              }
            ]}
          >
            Añadir pregunta
          </ButtonWithLogin>
        </div>
        <ModalFormForum
          open={openNewForm}
          onClose={handleCloseModal}
        />
      </div>
    </PublicAppContainer>
  )
}

export default ForumsScreenLayout
